import { createRouter, createWebHistory } from '@ionic/vue-router';
import { useStore } from '@/state/state';

const routes = [
  {
    path: '/',
    redirect: '/openapp'
  },
  // {
  //   path: '/:locationId/RegisterTenant',
  //   component: () => import('@/views/register-tenant.vue')      
  // },
  // {
  //   path: '/:locationId/designation/:designationId/category/:categoryId',
  //   component: () => import('@/views/view-procedure.vue'),
  // },
  {
    path: '/openapp/:locationId/respond-messaging/:incidentId',
    component: () => import('@/views/messages/respond.vue')
  },
  {
    path: '/openapp/:locationId/video-call/:incidentId',
    name: 'video-call',
    component: () => import('@/views/video-call.vue')
  },
  {
    path: '/openapp/:locationId/report-evac-history',
    component: () => import('@/views/messages/report-evac-history.vue'),
  },
  {
    path: '/openapp/:locationId/report-evac-internal',
    component: () => import('@/views/messages/report-evac-internal.vue'),
  },
  {
    path: '/:locationId/',
    component: () => import('@/views/TabsPage.vue'),
    children: [
      {
        path: 'RegisterTenant',
        component: () => import('@/views/register-tenant.vue'),
        meta: { requiresAuth: false }
      },
      {
        //https://onsite.tawcs.com.au/d949dc89-aa2c-4d7d-982d-79dee03b0ad2/designation/c5be9f95-6bc4-4a2f-8500-9715411fce8d/category/17ca1e6c-2aa4-432c-ac43-b9f18306da8a
        path: 'designation/:designationId/category/:categoryId',
        component: () => import('@/views/view-procedure.vue'),
        meta: { requiresAuth: false }
      },
    ]
  },
  {
    path: '/openapp/:locationId',
    component: () => import('@/views/TabsPage.vue'),
    children: [
      {
        path: 'capture-user',
        component: () => import('@/views/capture-user.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '',
        component: () => import('@/views/landing.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'default-procedure',
        component: () => import('@/views/landing.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'home',
        component: () => import('@/views/landing.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'view-procedure',
        component: () => import('@/views/default-procedure.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'designation/:designationId/selectedCategory/:categoryId',
        component: () => import('@/views/view-procedure.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'assembly-area',
        component: () => import('@/views/assembly-area.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'default-messaging',
        component: () => import('@/views/messages/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'report-evac',
        component: () => import('@/views/messages/report-evac.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'report-evac-history-internal',
        component: () => import('@/views/messages/report-evac-history-internal.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'open-incident/:incidentId',
        component: () => import('@/views/messages/open-incident.vue'),
        meta: { requiresAuth: true }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Authorised = currentLocation in store matches the route's locationId (by keyId OR qrcode)
// AND a loggedInUsers entry exists keyed by the canonical keyId.
// The route param may be either the internal keyId or the QR code UUID — both are accepted.
const isAuthorisedForLocation = (store, routeLocationId) => {
  const location = store.currentLocation;
  if (!location?.keyId) {
    console.log('[router] not authorised — no location in store');
    return false;
  }

  // Match route param against both keyId and qrcode (case-insensitive)
  const normalizedRouteId = routeLocationId?.toLowerCase();
  const normalizedKeyId = location.keyId.toLowerCase();
  const normalizedQrCode = location.qrcode?.toLowerCase();

  const locationMatches = normalizedRouteId === normalizedKeyId || normalizedRouteId === normalizedQrCode;
  if (!locationMatches) {
    console.log('[router] not authorised — location mismatch', {
      routeLocationId,
      keyId: location.keyId,
      qrcode: location.qrcode,
    });
    return false;
  }

  // Location matches — look up user by the canonical keyId
  const user = store.loggedInUsers?.[`${normalizedKeyId}:loggedinuser`];
  const authorised = !!(user?.name?.trim() && user?.mobile?.trim());
  console.log('[router] isAuthorisedForLocation:', authorised, {
    routeLocationId,
    keyId: location.keyId,
    userName: user?.name,
  });
  return authorised;
};

router.beforeEach((to) => {
  const store = useStore();
  const locationId = to.params.locationId;

  console.log('[router] beforeEach', {
    path: to.fullPath,
    requiresAuth: !!to.meta.requiresAuth,
    locationId,
  });

  // Only guard routes that explicitly require auth
  if (!to.meta.requiresAuth) {
    console.log('[router] no auth required — allow');
    return true;
  }

  if (!isAuthorisedForLocation(store, locationId)) {
    // Strip any existing 'redirect' from the original query, then forward
    // the remaining params (e.g. place1=food-court) directly onto the
    // capture-user URL so they're readable as plain query params.
    const { redirect: _existingRedirect, ...forwardQuery } = to.query;
    const captureQuery = {
      redirect: to.path,    // clean path only — no query string embedded
      ...forwardQuery,      // QR code params forwarded as sibling params
    };
    console.log('[router] not authorised — redirecting to capture-user', { path: `/openapp/${locationId}/capture-user`, query: captureQuery });
    return { path: `/openapp/${locationId}/capture-user`, query: captureQuery };
  }

  console.log('[router] authorised — allow');
  return true;
});

export default router 